<template>
<div class="grid mb-4">

<div class="col-12">
<div class="border-solid  border-round-sm border-3 toggle_trigger  animate_class" @click="toggle" :class="borderClass">
<h4 class="text-purple-500 my-2 mx-2 noselect inline-block my-3 pr-3" v-if="!completed"  v-badge.danger="missing_documents">{{title}}</h4>
<h4 class="text-green-500 my-2 mx-2 noselect my-3 " v-if="completed">{{success_title}}  <i class="pi pi-check ml-4 p-text-green-500" style="font-size: 1.3rem"></i></h4>
</div>
</div>

<div class="col-12 expand_content raised_item animate_class mt-2  px-4" v-if="toggleExpanse" transition="expand">
<slot name="content"></slot>
</div>


</div>
</template>

<script>
export default {

  name: 'CollapsePanel',
  props:["title","success_title","completed","missing_documents"],
  data () {
    return {
    	toggleExpanse:false,
    }
  },
  computed:{
    borderClass()
    {
      if(this.completed)
      {
        return "border-green-500"
      }
      else
      {
        return "border-purple-500"
      }
    }
  },
  methods: {
    toggle: function(){
      this.toggleExpanse = !this.toggleExpanse;
    }
  }
}
</script>

<style lang="css" scoped>
	.noselect {
    line-height: 1.6rem;
  -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
     -khtml-user-select: none; /* Konqueror HTML */
       -moz-user-select: none; /* Old versions of Firefox */
        -ms-user-select: none; /* Internet Explorer/Edge */
            user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */

}

.expand-enter-active,
.expand-leave-active {
  transition: opacity 2.5s ease;
}

.expand-enter-from,
.expand-leave-to {
  opacity: 0;
}
.toggle_trigger{
	cursor: pointer;
}
.expand_content{
}
</style>